import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorMessageService {
  getError(data: HttpErrorResponse): string {
    if (data.error.reason === 'invalid_form' && data.error?.messages) {
      let keys = Object.keys(data.error.messages);
      return keys
        .map(key => {
          return data.error.messages[key]?.join('. ');
        })
        ?.join('');
    }
    console.log(data);

    if (typeof data.error?.error === 'string') {
      return data.error.error.replace(/_/g, ' ');
    }

    return 'Server Error!';
  }
}
